// extracted by mini-css-extract-plugin
module.exports = {"focused":"_2Cc81","root":"_3V73f","input":"_17Emy","outerLabel":"_2zhGZ","innerLabel":"_3PIdC","toggleIcon":"_2Mp5n","checked":"_1k_W1","disabled":"_1RI-t"};